import React from 'react';

export default function PageNotFound() {
  return (
    <React.Fragment>
      This is page not found.
    </React.Fragment>
  );
}